import { Auth } from "@aws-amplify/auth";

export const logout = async () => {
  const currentSession = await Auth.currentSession();
  if (currentSession) await Auth.signOut();
  window.location.reload();
};
